import React from "react";
import styles from './footer.module.css';
import { AiFillYoutube, AiOutlineTwitter, AiFillLinkedin, AiFillMail, AiFillInstagram } from "react-icons/ai"
import { Link, useLocation, useNavigate } from "react-router-dom";


function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll to a section on the /page landing page
  const scrollToSection = (sectionId) => {
    if (location.pathname === '/page') {
      // Already on the landing page — scroll directly
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Navigate to /page first, then scroll after the page has mounted
      navigate('/page');
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 350);
    }
  };

  // Hide full footer content on UserSection (/dashboard/*, /codebox) and AdminSection (/admin/*) pages
  const isInternalPage =
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/codebox');

  // On internal pages, render only the sub-footer
  if (isInternalPage) {
    return (
      <footer className={styles.footer}>
        {/* Sub Footer Only */}
        <div className={styles.subFooter}>
          <div className={styles.subFooterRow}>
            <div className={styles.subFooterLeft}>
              <div className={styles.termsLinks}>
                <p>
                  <Link to="/privacy">Privacy</Link> |
                  <Link to="/terms">Terms</Link> |
                  <Link to="/contact">Support</Link>
                </p>
              </div>
            </div>
            <div className={styles.subFooterRight}>
              <div className={styles.copyright}>
                <p>&copy; 2025 SiliconLogix. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerContainer}>
          <div className={styles.footerGrid}>
            {/* Company Info Section */}
            <div className={styles.columnCompanyInfo}>
              <div className={styles.companySection}>
                <div className={styles.logoWrapper}>
                  <img src="/static_img/weblogo.png" alt="SiliconLogiX" />
                </div>
                {/* <div className={styles.companyName}>
                  SOCIETY FOR INTEGRATED LEARNING OF INTEGRATED CIRCUIT, COMMUNICATION AND NETWORKING SYSTEMS
                </div> */}
                <p className={styles.companyDescription}>
                  Empowering electronics & hardware engineers with an interactive learning platform and tools for hands-on learning across VLSI, IoT, Embedded Systems, and other Digital Systems.
                </p>
                <div className={styles.socialIcons}>
                  <ul className={styles.socialNetwork}>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/silicon_logix_in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="LinkedIn"
                      >
                        <AiFillLinkedin size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/siliconlogix/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <AiFillInstagram size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/siliconlogix"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Youtube"
                      >
                        <AiFillYoutube size={22} />
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="mailto:contact@siliconlogix.in"
                        title="Email Us"
                      >
                        <AiFillMail size={22} />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            {/* Product Section */}
            <div className={styles.columnQuickLinks}>
              <div className={styles.quickLinksSection}>
                <h6>PRODUCT</h6>
                <ul className={styles.linkList}>
                  <li><Link to="/ide">Codebox</Link></li>
                  <li><button className={styles.footerSectionBtn} onClick={() => scrollToSection('challenges')}>Challenges</button></li>
                  <li><button className={styles.footerSectionBtn} onClick={() => scrollToSection('challenges')}>Exercises</button></li>
                  <li><button className={styles.footerSectionBtn} onClick={() => scrollToSection('examples')}>Examples</button></li>
                  <li><button className={styles.footerSectionBtn} onClick={() => scrollToSection('features')}>Features</button></li>
                </ul>
              </div>
            </div>

            {/* Tools Section */}
            <div className={styles.columnResources}>
              <div className={styles.quickLinksSection}>
                <h6>TOOLS</h6>
                <ul className={styles.linkList}>
                  <li><a href="https://steveicarus.github.io/iverilog/" target="_blank" rel="noopener noreferrer">Icarus Verilog</a></li>
                  <li><a href="https://www.veripool.org/verilator/" target="_blank" rel="noopener noreferrer">Verilator</a></li>
                  <li><a href="https://yosyshq.net/yosys/" target="_blank" rel="noopener noreferrer">Yosys Synthesis</a></li>
                  <li><a href="https://opensta.org/" target="_blank" rel="noopener noreferrer">OpenSTA</a></li>
                  <li><a href="https://skywater-pdk.readthedocs.io/" target="_blank" rel="noopener noreferrer">SkyWater 130nm</a></li>
                </ul>
              </div>
            </div>

            {/* Account Section */}
            <div className={styles.columnContactInfo}>
              <div className={styles.quickLinksSection}>
                <h6>ACCOUNT</h6>
                <ul className={styles.linkList}>
                  <li><Link to="/login">Sign In</Link></li>
                  <li><Link to="/signup">Sign Up</Link></li>
                  <li><a href="mailto:contact@siliconlogix.in">Contact Support</a></li>
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                  <li><Link to="/terms">Terms</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sub Footer */}
      <div className={styles.subFooter}>
        <div className={styles.subFooterRow}>
          <div className={styles.subFooterLeft}>
            <div className={styles.termsLinks}>
              <p>
                <Link to="/privacy">Privacy</Link> |
                <Link to="/terms">Terms</Link> |
                <Link to="/contact">Support</Link>
              </p>
            </div>
          </div>
          <div className={styles.subFooterRight}>
            <div className={styles.copyright}>
              <p>&copy; 2025 SiliconLogix. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
